import { render } from "./CollapseTransition.vue?vue&type=template&id=63e573f1"
import script from "./CollapseTransition.vue?vue&type=script&lang=js"
export * from "./CollapseTransition.vue?vue&type=script&lang=js"
script.render = render

export default script